import { Component, Input, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FilePickerComponent } from 'src/app/shared/file-picker/file-picker.component';
import { TurnstileComponent } from 'src/app/shared/turnstile/turnstile.component';
import {
  FormGroup,
  FormGroupDirective,
  ReactiveFormsModule,
} from '@angular/forms';
import {
  DumbControlConfiguration,
  DynamicControlConfiguration,
} from '../../interfaces/dynamic-form-controls';

@Component({
  selector: 'app-dumb-form-control',
  standalone: true,
  imports: [
    CommonModule,
    FilePickerComponent,
    TurnstileComponent,
    ReactiveFormsModule,
  ],
  template: `
    <div [formGroup]="formGroup">
      <label
        *ngIf="showLabel && config.displayName"
        [for]="config.name"
        class="block whitespace-nowrap"
      >
        {{ config.displayName }}
        <span class="text-red-600" *ngIf="config.reqiuired">*</span>
      </label>
      <ng-container [ngSwitch]="config.type">
        <input
          [id]="config.name"
          [formControlName]="config.name"
          *ngSwitchCase="'text'"
        />
        <textarea
          [id]="config.name"
          [formControlName]="config.name"
          *ngSwitchCase="'multiline'"
        ></textarea>
        <app-file-picker
          [id]="config.name"
          [formControlName]="config.name"
          *ngSwitchCase="'file'"
        ></app-file-picker>
      </ng-container>
      <div class="">
        <small
          class="text-red-700"
          *ngIf="
            formGroup?.get(config.name)?.hasError('required') &&
            formGroup.get(config.name)?.dirty
          "
        >
          {{ config.displayName }} är obligatoriskt
        </small>
      </div>
    </div>
  `,
})
export class DumbFormControlComponent {
  @Input() showLabel = true;

  @Input('config') input!: DynamicControlConfiguration;
  get config(): DumbControlConfiguration {
    return this.input as DumbControlConfiguration;
  }

  formGroupDirective = inject(FormGroupDirective);
  get formGroup(): FormGroup {
    return this.formGroupDirective.form;
  }
}
